import { render, staticRenderFns } from "./LawExpertOpinionOutcomeForm.vue?vue&type=template&id=f5100012&"
import script from "./LawExpertOpinionOutcomeForm.vue?vue&type=script&lang=js&"
export * from "./LawExpertOpinionOutcomeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawExpertOpinionOutcomeForm.vue?vue&type=style&index=0&id=f5100012&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports